module.exports = __webpack_public_path__ + "media/src/images/testimonials/dominic-berchtold-88de042770ecbc4eb0ba29db7b69d283.jpg";